#import "../../../../../../../../../../../common/graphql/EntityDocumentsFields.graphql"

query AttachableTripDocuments(
  $after: Cursor
  $documentTypeId: Int
  $filter: EntityDocumentFilter
  $first: Int
  $orderBy: [EntityDocumentsOrderBy!]
  $tripId: UUID!
) {
  attachableTripDocuments(
    first: $first
    after: $after
    tripId: $tripId
    orderBy: $orderBy
    filter: $filter
    documentTypeId: $documentTypeId
  ) {
    nodes {
      ...EntityDocumentsFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
